module.exports = __webpack_public_path__ + "img/package-added-en.3550113.png";